module.exports = __webpack_public_path__ + "img/Path 17@3x.65001659.png";